module.exports = __webpack_public_path__ + "img/9791187038245.6b3208e5.jpg";